import { type AnyRedirect, redirect } from '@tanstack/react-router'

import type { AdminMeResponse } from '@gto/api-client/admin/react-query'

import { ADMIN_SECTIONS_BY_ID, type AdminSectionId, canManageSection } from './sections'

export const requireManage = (
  me: AdminMeResponse,
  sectionId: AdminSectionId,
  fallback: AnyRedirect,
): void => {
  if (!canManageSection(me, ADMIN_SECTIONS_BY_ID[sectionId])) {
    redirect({ ...fallback.options, throw: true })
  }
}
